enum Stores {
    US = 'us-store',
    CA = 'ca-store',
}

const webInventoryToStore = {
    ps_ca_web_inv: 'ca-store',
    ps_us_web_inv: 'us-store',
};

const STORE_ID_PATTERN = /^(?!0+$)\d{1,4}$/;

export { STORE_ID_PATTERN, Stores, webInventoryToStore };
